import { defineStore } from 'pinia'

export const ReportData = defineStore('r_data', {
    state: () => {
        return { r_data: null }
    },
    actions: {
        get() {
            return this.r_data
        },
        set(value) {
            this.r_data = value
        }
    },
})